var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({staticClass:"btn btn-green",attrs:{"tabindex":_vm.disabled ? '-1' : '0',"disabled":_vm.disabled}},'button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",function(){return [_vm._v("Click me")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }